/* eslint-disable @next/next/no-img-element */
import { P, rem, Spacer } from 'design-system';

import { Section, SectionInner } from '../components/section';

// Maintenance window: Apr 27, 2026, 7:00 AM - 7:30 AM IST (1:30 AM - 2:00 AM UTC)
const MAINTENANCE_START = Date.UTC(2026, 3, 27, 1, 30); // 2026-04-27  01:30:00 UTC
const MAINTENANCE_END = Date.UTC(2026, 3, 27, 2, 0); // 2026-04-27   02:00:00 UTC
const BANNER_SHOW_TIME = MAINTENANCE_START - 72 * 60 * 60 * 1000; // Show banner 72 hours before maintenance

export const ServiceUnavailableBanner = () => {
  const now = Date.now();

  let message = null;

  if (now < BANNER_SHOW_TIME) {
    // Don't show banner yet (more than 72 hours before maintenance)
    return null;
  } else if (now >= BANNER_SHOW_TIME && now < MAINTENANCE_START) {
    // 72 hours before maintenance until maintenance starts
    message = (
      <>
        Preflight will undergo scheduled maintenance from{' '}
        <b>1:30 AM to 2:00 AM UTC on April 27, 2026.</b>
      </>
    );
  } else if (now >= MAINTENANCE_START && now < MAINTENANCE_END) {
    // During maintenance
    message = (
      <>
        Preflight is currently undergoing scheduled maintenance until{' '}
        <b>2:00 AM UTC on April 27, 2026.</b>
      </>
    );
  } else {
    // After maintenance, do not show banner
    return null;
  }

  return (
    <Section
      // eslint-disable-next-line custom/no-hardcoded-colors
      style={{
        backgroundColor: '#ffeaee',
      }}
    >
      <Spacer height={24} />
      <SectionInner
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: rem(1104),
        }}
      >
        <div
          // eslint-disable-next-line custom/no-hardcoded-colors, custom/no-unsafe-stitches-tokens
          style={{
            color: '#8c2f45',
            fontWeight: 'medium',
            display: 'flex',
            gap: rem(10),
            alignItems: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          {/* <WarningIcon width={rem(24)} /> */}

          <img
            role="img"
            src="/warning-icon.svg"
            alt="Warning Icon"
            width={18}
            height={18}
          />
          <P
            size="medium"
            // eslint-disable-next-line custom/no-hardcoded-colors, custom/no-unsafe-stitches-tokens
            style={{
              color: '#8c2f45',
              fontWeight: 'medium',
              textAlign: 'center',
              whiteSpace: 'nowrap',
              margin: 0,
              padding: 0,
            }}
          >
            {message}
          </P>
        </div>
      </SectionInner>
      <Spacer height={24} />
    </Section>
  );
};
